import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiResultReview from './KpiResultReview';
import Badge from '../badges/Badge';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as dialogHelper from '../../../helpers/dialogHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as localStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {
    LEANER_ACTION_REVIEW_CONFIG,
    MULTIPLE_CHOICE_REVIEW_CONFIG,
    MULTIPLE_ANSWER_REVIEW_CONFIG,
    SHORT_ANSWER_REVIEW_CONFIG,
    ORDERING_MATCHING_REVIEW_CONFIG
} from '../../../models/dialogModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';


class KpiBarGraphItem extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            guid: dataHelper.createGuid(),
            userData: this.props.userData,
            kpiData: this.props.kpiData,
            userDataKpi: this.props.userDataKpi,
            tooltipId: `tooltip_${this.props.userDataKpi.asset_id}`,
            optionDetails: this.props.userDataKpi.option_id.length > 0 ? appHelper.getOptionParentDetails(this.props.userDataKpi.option_id[0]) : appHelper.getAssetParentDetails(this.props.userDataKpi.asset_id),
            objectLocale: {},
            //kpiDefaults: appHelper.getArrayObjectByKey(this.props.bite.kpis, "code", this.props.kpi_id),
            showTooltip: false,
            currentTooltipId: this.props.currentTooltipId,
            checkTooltipState: false,
            responseData: {},
            //badges
            badgesEarned: [],
            checkBadgeEarned: false,
            showAchievedState: false,
            showAchievedCount: false,
            //
            updateTooltip: false,
            updateChart: false,
            review_response_label: appHelper.getLocaleString("review_response_label"),
            go_to_screen_label: appHelper.getLocaleString("go_to_screen_label")
        };

        this.setObjectLocale = this.setObjectLocale.bind(this);
        this.setResponseData = this.setResponseData.bind(this);
        this.setSingleAnswerResponseData = this.setSingleAnswerResponseData.bind(this);
        this.setMultiAnswerResponseData = this.setMultiAnswerResponseData.bind(this);
        this.setOrderingMatchingResponseData = this.setOrderingMatchingResponseData.bind(this);
        this.setSelfRatingResponseData = this.setSelfRatingResponseData.bind(this);
        this.setItemHeight = this.setItemHeight.bind(this);
        this.setGraphItemClass = this.setGraphItemClass.bind(this);
        this.setToolTipClass = this.setToolTipClass.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.setTooltipVisibility = this.setTooltipVisibility.bind(this);
        this.onToolGraphItemHit = this.onToolGraphItemHit.bind(this);
        this.onToolGraphItemClicked = this.onToolGraphItemClicked.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.goToScreen = this.goToScreen.bind(this);
        //badges
        this.checkBadgeEarnedOnObject = this.checkBadgeEarnedOnObject.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.onToolGraphItemKeyboardAccessed = this.onToolGraphItemKeyboardAccessed.bind(this);
        this.goToScreenKeyBoardAccessed = this.goToScreenKeyBoardAccessed.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.setTooltipVisibility();
        this.setResponseData();
        this.setObjectLocale();
        this.setItemHeight();
        this.checkBadgeEarnedOnObject();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkBadgeEarnedOnObject: true
            });
        }
        if (this.state.currentTooltipId !== nextProps.currentTooltipId) {
            this.setState({currentTooltipId: nextProps.currentTooltipId, updateTooltip: true});
        }

        if (this.state.userDataKpi !== nextProps.userDataKpi) {
            this.setState({
                userDataKpi: Object.assign({}, nextProps.userDataKpi),
                updateChart: true,
                //optionDetails: appHelper.getOptionParentDetails(nextProps.option_id[0]),
                //tooltipId: `tooltip_${nextProps.userDataKpi.option_id[0]}`,
            });
        }

        if (this.state.kpiData !== nextProps.kpiData) {
            this.setState({kpiData: Object.assign({}, nextProps.kpiData), updateChart: true});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                objectLocale: appHelper.getLocalData(this.state.optionDetails.object),
                review_response_label: appHelper.getLocaleString("review_response_label"),
                go_to_screen_label: appHelper.getLocaleString("go_to_screen_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.checkBadgeEarned) {
            this.checkBadgeEarnedOnObject();
        }

        if (this.state.updateTooltip) {
            this.setTooltipVisibility();
        }

        if (this.state.updateChart) {
            this.setItemHeight();
            this.setObjectLocale();
        }
    }

    setResponseData() {
        if (this.props.userDataKpi.option_id.length > 0) {
            if (this.state.optionDetails.object.object_type === componentConstants.MULTIPLE_CHOICE || this.state.optionDetails.object.object_type === componentConstants.CONVERSATION_CHOICE || this.state.optionDetails.object.object_type === componentConstants.GRID_CHOICE || this.state.optionDetails.object.object_type === componentConstants.SWIPE_HORIZONTAL) {
                if (this.props.userDataKpi.option_id.length === 1 && appHelper.isDefined(this.state.optionDetails.object.selection_type) !== objectConstants.SELECTION_TYPE_SELECT_MANY) {
                    this.setSingleAnswerResponseData();
                } else {
                    this.setMultiAnswerResponseData();
                }
            } else if (this.state.optionDetails.object.asset_type_code === componentConstants.ORDERING || this.state.optionDetails.object.asset_type_code === componentConstants.MATCHING) {
                this.setOrderingMatchingResponseData();
            }
        } else {
            this.setSelfRatingResponseData();
        }
    }

    setSingleAnswerResponseData() {
        let responses = [];
        let response = {
            selectedOption: this.state.optionDetails.option
        };
        this.setState(
            {
                responseData: Object.assign({}, this.state.responseData,
                    {
                        bite_id: this.state.optionDetails.bite.bite_id,
                        screen_id: this.state.optionDetails.screen.screen_id,
                        object_id: this.state.optionDetails.object.object_id,
                        currentAttempt: 1,
                        currentStatus: objectConstants.STATUS_COMPLETE,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        responses: dataHelper.immutablePush(responses, response),
                        latestResponse: this.state.optionDetails.option
                    }
                )
            }
        );
    }

    setMultiAnswerResponseData() {
        this.setState(
            {
                responseData: Object.assign({}, this.state.responseData,
                    {
                        bite_id: this.state.optionDetails.bite.bite_id,
                        screen_id: this.state.optionDetails.screen.screen_id,
                        object_id: this.state.optionDetails.object.object_id,
                        currentAttempt: 1,
                        currentStatus: objectConstants.STATUS_COMPLETE,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        userSelections: appHelper.getObjectCheckedOptionsByKpiHistoryOptions(this.props.userDataKpi.option_id),
                        checkedOptions: appHelper.getObjectCheckedOptionsByKpiHistoryOptions(this.props.userDataKpi.option_id),
                        outcome: appHelper.getObjectOutcomeByKpiHistoryOptions(this.props.userDataKpi.option_id)
                    }
                )
            }
        );
    }

    setOrderingMatchingResponseData() {
        let checkedOptions = appHelper.getObjectCheckedOptionsByKpiHistoryOptions(this.props.userDataKpi.option_id);
        let options = [];
        _.forEach(this.state.optionDetails.object.options, function (optionData, index) {
            let option = Object.assign({}, optionData, {
                answered: true,
                is_correct: optionData.option_id === checkedOptions[index].option_id,
                selected_option: checkedOptions[index],
                default_option: checkedOptions[index]
            });
            options = dataHelper.immutablePush(options, option);
        });

        //console.log(`checkedOptions`,checkedOptions);
        let outcome = appHelper.getOrderingObjectOutcomeByKpiHistoryOptions(options);

        this.setState(
            {
                responseData: Object.assign({}, this.state.responseData,
                    {
                        bite_id: this.state.optionDetails.bite.bite_id,
                        screen_id: this.state.optionDetails.screen.screen_id,
                        object_id: this.state.optionDetails.object.object_id,
                        currentAttempt: 1,
                        currentStatus: objectConstants.STATUS_COMPLETE,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        userSelections: options,
                        checkedOptions: options,
                        outcome: outcome
                    }
                )
            }
        );
    }

    setSelfRatingResponseData() {
        this.setState(
            {
                responseData: Object.assign({}, this.state.responseData,
                    {
                        bite_id: this.state.optionDetails.bite.bite_id,
                        screen_id: this.state.optionDetails.screen.screen_id,
                        object_id: this.state.optionDetails.object.asset_id,
                        asset_id: this.state.optionDetails.object.asset_id,
                        currentAttempt: 1,
                        currentStatus: objectConstants.STATUS_COMPLETE,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        kpis: [
                            {
                                kpi_id: this.props.kpi_id,
                                value: appHelper.isDefined(this.state.userDataKpi.statusIndicatorClass.value) && !isNaN(this.state.userDataKpi.statusIndicatorClass.value) ? this.state.userDataKpi.statusIndicatorClass.value : null
                            }
                        ]
                    }
                )
            }
        );
    }

    setObjectLocale() {
        let locale = appHelper.getLocalData(this.state.optionDetails.object);
        this.setState({objectLocale: Object.assign({}, locale)});
    }

    setItemHeight() {
        this.setState({updateChart: false});
        let itemHeight = dataHelper.getRangePercentage(this.props.min, this.props.max, this.props.userDataKpi.current);
        let itemWidth = (100 / this.props.totalItems);
        let leftPos = (itemWidth * this.props.index);
        let item = this.objectRef.current;

        if(appHelper.isEleDefined(item)){
            TweenLite.set(item, {
                height: `${itemHeight}%`,
                width: `${itemWidth}%`,
                left: `${leftPos}%`,
                opacity: 1,
            });

            TweenLite.from(item, 0, {
                height: 0,
                width: `${itemWidth}%`,
                left: `${leftPos}%`,
                opacity: 0,
                ease: Expo.easeInOut
            });
        }
    }

    setGraphItemClass() {
        let itemClass = "";
        //console.log(this.state.userDataKpi);
        //console.log(`statusIndicatorClass`,this.state.userDataKpi.statusIndicatorClass);
        if (appHelper.isDefined(this.state.userDataKpi.statusIndicatorClass) && this.state.optionDetails.object.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE) {
            if (this.state.userDataKpi.statusIndicatorClass.class === "negative-single" || this.state.userDataKpi.statusIndicatorClass.class === "negative-double") {
                itemClass += "negative ";
            } else if (this.state.userDataKpi.statusIndicatorClass.class === "positive-single" || this.state.userDataKpi.statusIndicatorClass.class === "positive-double") {
                itemClass += "positive ";
            } else if (!this.state.userDataKpi.hasValue) {
                itemClass += "reflective ";
            } else {
                itemClass += "neutral ";
            }
        } else if (this.state.optionDetails.object.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
            itemClass += "reflective ";
        } else {
            itemClass += "reflective ";
        }

        if (this.state.currentTooltipId === this.state.tooltipId) {
            itemClass += "active ";
        }

        if (this.state.badgesEarned.length > 0) {
            itemClass += "has-badges";
        }

        return itemClass;
    }

    setToolTipClass() {
        if (((this.props.index + 1) <= (this.props.totalItems / 2)) || this.props.totalItems <= 2) {
            return "left";
        } else {
            return "right";
        }
    }

    onReviewObject() {
        let reviewActionCongigType = LEANER_ACTION_REVIEW_CONFIG;

        if (this.state.optionDetails.object.object_type === componentConstants.MULTIPLE_CHOICE || this.state.optionDetails.object.object_type === componentConstants.CONVERSATION_CHOICE || this.state.optionDetails.object.object_type === componentConstants.GRID_CHOICE || this.state.optionDetails.object.object_type === componentConstants.SWIPE_HORIZONTAL) {
            if (this.state.optionDetails.object.selection_type === objectConstants.SELECTION_TYPE_SELECT_ONE) {
                reviewActionCongigType = MULTIPLE_CHOICE_REVIEW_CONFIG;
            } else if (this.state.optionDetails.object.selection_type === objectConstants.SELECTION_TYPE_SELECT_MANY) {
                reviewActionCongigType = MULTIPLE_ANSWER_REVIEW_CONFIG;
            }
        } else if (this.state.optionDetails.object.asset_type_code === componentConstants.ORDERING || this.state.optionDetails.object.asset_type_code === componentConstants.MATCHING) {
            reviewActionCongigType = ORDERING_MATCHING_REVIEW_CONFIG;
        }/*else if(this.state.optionDetails.object.object_type ===  componentConstants.SHORT_RESPONSE){

            reviewActionCongigType = SHORT_ANSWER_REVIEW_CONFIG;
        }*/

        let config = Object.assign({}, reviewActionCongigType,
            {
                title: this.state.objectLocale.label,
                sourceId: `${this.state.userDataKpi.asset_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child.componentProps = Object.assign({}, {
                screenObject: this.state.optionDetails.object,
                responseData: Object.assign({}, this.state.responseData)
            });
        }

        this.props.actions.setNewDialog(config);
    }

    toggleTooltip() {
        this.setState({showTooltip: !this.state.showTooltip});
    }

    onToolGraphItemHit(event) {
        if (this.state.tooltipId !== this.state.currentTooltipId) {
            this.props.onSetTooltip(this.state.tooltipId);
        }

    }

    onToolGraphItemClicked(event) {
        /*if(this.state.tooltipId !== this.state.currentTooltipId){
            this.props.onSetTooltip(this.state.tooltipId);
        }*/
        this.onReviewObject();
    }

    onToolGraphItemKeyboardAccessed(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onReviewObject();
        }
    }

    setTooltipVisibility() {
        this.setState({updateTooltip: false});
        if (this.state.currentTooltipId === this.state.tooltipId) {
            this.showTooltip();
        } else {
            this.hideTooltip();
        }
    }

    showTooltip() {
        this.setState({showTooltip: true});
    }

    hideTooltip() {
        this.setState({showTooltip: false});
    }

    goToScreen(event) {
        event.stopPropagation();
        let screen_id = this.state.optionDetails.screen.screen_id;
        this.props.actions.setNewLessonLocation(screen_id);
    }

    goToScreenKeyBoardAccessed(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            let screen_id = this.state.optionDetails.screen.screen_id;
            this.props.actions.setNewLessonLocation(screen_id);
        }
    }

    checkBadgeEarnedOnObject() {
        let params = {
            bite_id: this.state.optionDetails.bite.bite_id,
            asset_id: this.state.optionDetails.object.asset_id
        };

        let badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        this.setState({
            checkBadgesEarned: false,
            badgesEarned: Object.assign([], badgesEarned)
        });
    }

    getBadge(badge_id) {
        let badges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.state.optionDetails.bite.bite_id).badges;
        return appHelper.getArrayObjectByKey(badges, "badge_id", badge_id);
    }

    render() {
        return (
            <div className={`graph-item ${this.setGraphItemClass()}`} ref={this.objectRef}
                 id={this.state.userDataKpi.asset_id} onMouseEnter={this.onToolGraphItemHit}
                 onFocus={this.onToolGraphItemHit} onClick={this.onToolGraphItemClicked}
                 onKeyDown={this.onToolGraphItemKeyboardAccessed} role="link" tabIndex="0">
                {this.state.badgesEarned.length
                    ? <div className="badge-earned"/>
                    : null
                }
                <div className="graph-item-marker"/>
                {this.state.showTooltip
                    ?
                    <div className={`graph-item-tool-tip ${this.setToolTipClass()} `}>
                        <div className="tool-tip-title"><span>{this.state.objectLocale.label}</span></div>
                        <div className="flex-row">
                            {this.state.badgesEarned.length > 0
                                ?
                                <div className="flex-item">

                                    <ul className="badge-grid">
                                        {this.state.badgesEarned.map(badge =>
                                            <li key={badge.badge_id} className="badge-grid-item">
                                                <Badge badge={this.getBadge(badge.badge_id)}
                                                       userBadge={badge}
                                                       showAchievedCount={this.state.showAchievedCount}
                                                       showAchievedState={this.state.showAchievedState}/>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                :
                                null
                            }

                            {this.props.userDataKpi.hasValue && this.state.optionDetails.object.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE
                                ?
                                <div className="flex-item">
                                    <div className="kpi-meter-wrapper">
                                        <KpiResultReview kpiDefaults={this.state.kpiData}
                                                         kpi={{
                                                             value: this.props.userDataKpi.statusIndicatorClass.value,
                                                             kpi_id: this.props.userDataKpi.kpi_id
                                                         }}/>
                                    </div>
                                </div>
                                : null
                            }

                        </div>

                        <div className="inline-content mobile-block even-widths text-center">
                            <div className="content-item-review  guroo-active-link no-wrap "
                                 id={`link_${this.state.userDataKpi.asset_id}`} onClick={this.onReviewObject}
                                 onKeyDown={this.onToolGraphItemKeyboardAccessed} role="link" tabIndex="0"
                                 dangerouslySetInnerHTML={{__html: this.state.review_response_label}}/>
                        </div>
                    </div>
                    : null
                }
                {this.state.showTooltip
                    ? <div className={`graph-item-tool-tip-arrow`}/>
                    : null
                }
            </div>
        );
    }
}

/*
*  <div className="content-item-spacer "/>
                            <div className="content-item-review  guroo-active-link no-wrap" onClick={this.goToScreen} onKeyDown={this.goToScreenKeyBoardAccessed} role="link" tabIndex="0" dangerouslySetInnerHTML={{__html: this.state.go_to_screen_label}} />
* */

KpiBarGraphItem.propTypes = {
    kpi_id: PropTypes.number.isRequired,
    kpiData: PropTypes.object.isRequired,
    userDataKpi: PropTypes.object.isRequired,
    totalItems: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    currentTooltipId: PropTypes.string.isRequired,
    onSetTooltip: PropTypes.func.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object,

};

KpiBarGraphItem.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiBarGraphItem);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiBarGraphItem.js
 **/